var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpcmarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5071 38.4834C33.8748 36.1406 40 28.5926 40 19.6432C40 8.8226 31.0457 0.0507812 20 0.0507812C8.9543 0.0507812 0 8.8226 0 19.6432C0 29.2975 7.12806 37.3208 16.5098 38.9383L20.8692 46.0558L25.5071 38.4834Z",
    fill: "#FF881B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_17768",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 31,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.44434,
    y: 3.04883,
    width: 29.6296,
    height: 29.6293,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_17768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0871 27.7386H27.902V25.2695H13.0871V27.7386ZM13.0871 22.8004H27.902V20.3313H13.0871V22.8004ZM13.0871 17.8622H27.902V16.7511L26.1118 15.393H14.8773L13.0871 16.7511V17.8622ZM18.0871 12.9239H22.902L20.4946 11.103L18.0871 12.9239ZM10.618 30.2077V18.6338L8.39579 20.3313L6.91431 18.356L10.618 15.5165V11.6894H13.0871V13.6338L20.4946 7.98571L34.0748 18.356L32.5933 20.3004L30.3711 18.6338V30.2077H10.618ZM10.618 10.4548C10.618 9.42603 10.9781 8.55155 11.6983 7.83139C12.4184 7.11124 13.2929 6.75116 14.3217 6.75116C14.6715 6.75116 14.9647 6.63285 15.2013 6.39622C15.438 6.1596 15.5563 5.86639 15.5563 5.5166H18.0254C18.0254 6.5454 17.6653 7.41988 16.9452 8.14003C16.225 8.86019 15.3505 9.22027 14.3217 9.22027C13.9719 9.22027 13.6787 9.33858 13.4421 9.5752C13.2055 9.81183 13.0871 10.105 13.0871 10.4548H10.618Z",
    fill: "#FAF3E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpcmarker);
export default __webpack_public_path__ + "static/media/epcmarker.fa1a7364924094ebb96e28fe387e10a0.svg";
export { ForwardRef as ReactComponent };